import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { ToastProvider } from '@myron/design-system';
import { ApiErreur } from '../shared/api/client';
import { SessionProvider } from '../shared/auth/session';
import { GestionnaireReauthentification } from '../features/auth/Reauthentification';
import { creerRouteur } from './router';

export function creerQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        refetchOnWindowFocus: false,
        // Pas de nouvel essai sur les refus d'accès ou de validation (déterministes).
        retry: (n, e) => !(e instanceof ApiErreur && e.status >= 400 && e.status < 500) && n < 1,
      },
      mutations: { retry: false },
    },
  });
}

export function App() {
  const [qc] = useState(creerQueryClient);
  const [routeur] = useState(creerRouteur);
  return (
    <QueryClientProvider client={qc}>
      <ToastProvider>
        <SessionProvider>
          <GestionnaireReauthentification />
          <RouterProvider router={routeur} />
        </SessionProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
